<script setup>

import TelegramChat from "@/components/PersonalAccount/TelegramChat/TelegramChat.vue";
</script>

<template>
  <div class="personalAccount">
    <section class="personalAccount__detail">
      <nav class="personalAccount__navigation" aria-label="Разделы профиля">
        <router-link :to="{name: 'ContactsView'}">Данные профиля</router-link>
        <router-link :to="{name: 'OrdersView'}">Покупки</router-link>
        <router-link :to="{name: 'AcquiredCoinsView'}">Монеты</router-link>
        <router-link :to="{name: 'ClubSignupStatusView'}">Заявка в клуб</router-link>
      </nav>
      <router-view/>
    </section>
    <section class="personalAccount__tools">
      <TelegramChat/>
    </section>
  </div>
</template>

<style scoped lang="scss">
.personalAccount {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 24px;
  align-items: start;

  // Планшет: detail сверху, tools — под ним
  @include respond-to('lg') {
    grid-template-columns: 1fr;
    grid-template-areas:
      "detail"
      "tools";
  }

  // Мобиле: flex-column — просто стек
  @include respond-to('md') {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__detail {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
    @include respond-to('lg') { grid-area: detail; }
  }

  &__navigation {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    a {
      padding: 8px 14px;
      border: 1px solid var(--cd-spoiler-border-color);
      border-radius: 100px;
      color: var(--cd-text-muted);
      font-family: var(--cd-default-font);
      text-decoration: none;
      transition: color 0.2s, background-color 0.2s, border-color 0.2s;

      &:hover,
      &.router-link-active {
        border-color: var(--cd-base-green);
        background-color: var(--cd-button-bg-color);
        color: var(--cd-highlight-text);
      }
    }
  }

  &__tools {
    @include respond-to('lg') { grid-area: tools; }
  }
}
</style>
